"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
require("./RepositoryOwnerPanelHeader.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var RepositoryOwnerPanelHeader = function RepositoryOwnerPanelHeader(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "repository-owner-panel-header bolt-panel-header"
  }, /*#__PURE__*/React.createElement("div", {
    "aria-level": 1,
    className: "flex-grow bolt-header-title title-m l",
    id: "__bolt-panel-1-title",
    role: "heading"
  }, props.isLoading ? /*#__PURE__*/React.createElement(_react2.Shimmer, {
    className: "margin-bottom-4",
    shimmerElements: [{
      type: _react2.ShimmerElementType.line,
      height: 28
    }],
    width: "25%"
  }) : props.repoDetails.name), /*#__PURE__*/React.createElement("div", {
    className: "bolt-header-description body-m secondary-text"
  }, props.isLoading ? /*#__PURE__*/React.createElement(_react2.Shimmer, {
    width: "40%"
  }) : props.repoDetails.location));
};
var _default = RepositoryOwnerPanelHeader;
exports.default = _default;